module.exports = __webpack_public_path__ + "img/mouse-pointer.4af98ea7.svg";